document.addEventListener("DOMContentLoaded", function () { 
  document.body.setAttribute('data-toc-initialized', 'true');

  const headings = document.querySelectorAll(
    ".article__content h2, .article__content h3"
  );
  const tocInline = document.getElementById("dynamic-toc");
  const tocDesktop = document.getElementById("desktop-toc");

  if (!headings.length) return;

  // Utility-Funktion zum Erzeugen von Slugs
  const createSlug = (str) =>
    str
      .trim()
      .toLowerCase()
      .replace(/[^\w]+/g, "-");

  // Funktion zur Erstellung der ToC-Liste
  function createTocList() {
    const tocList = document.createElement("ul");
    tocList.classList.add("toc-list");

    const tocTitle = document.createElement("li");
    tocTitle.className = "toc-title h5";

    const tocSpan = document.createElement("span");
    tocSpan.textContent = "Inhaltsverzeichnis";
    tocSpan.style.verticalAlign = "middle";

    tocTitle.appendChild(tocSpan);
    tocList.appendChild(tocTitle);

    let currentH2Item = null;
    let currentSubList = null;

    headings.forEach((heading) => {
      if (!heading.id) {
        heading.id = createSlug(heading.textContent);
      }

      const tag = heading.tagName;

      if (tag === "H2") {
        currentSubList = null;

        const h2Item = document.createElement("li");
        h2Item.className = "toc-item";

        const toggleWrapper = document.createElement("div");
        toggleWrapper.className = "toc-toggle-wrapper";

        const link = document.createElement("a");
        link.href = `#${heading.id}`;
        link.textContent = heading.textContent;
        link.className = "toc-toggle-text";

        toggleWrapper.appendChild(link);
        h2Item.appendChild(toggleWrapper);

        tocList.appendChild(h2Item);
        currentH2Item = h2Item;
      }

      if (tag === "H3" && currentH2Item) {
        if (!currentSubList) {
          currentSubList = document.createElement("ul");
          currentSubList.classList.add("toc-sublist");
          currentH2Item.appendChild(currentSubList);

          const toggleBtn = document.createElement("button");
          toggleBtn.className = "toc-toggle";
          toggleBtn.setAttribute("aria-expanded", "false");

          const chevron = document.createElement("span");
          chevron.className = "chevron-icon";
          toggleBtn.appendChild(chevron);

          currentH2Item
            .querySelector(".toc-toggle-wrapper")
            .appendChild(toggleBtn);
        }

        const h3Item = document.createElement("li");
        const h3Link = document.createElement("a");
        h3Link.href = `#${heading.id}`;
        h3Link.textContent = heading.textContent;
        h3Item.appendChild(h3Link);
        currentSubList.appendChild(h3Item);
      }
    });

    return tocList;
  }

  // Funktion zur Erstellung des Burger-Menü-Icons
  function createBurgerIcon() {
    const btn = document.createElement("button");
    btn.className = "toc-burger";
    btn.setAttribute("aria-label", "Inhaltsverzeichnis ein-/ausklappen");
    btn.setAttribute("aria-expanded", "true");
    btn.style.transform = "rotate(-45deg)";
    btn.innerHTML = `
      <span class="icon--to-open motion-reduce">
        <svg 
          xmlns="http://www.w3.org/2000/svg" 
          aria-hidden="true" 
          focusable="false" 
          role="presentation" 
          viewBox="0 0 24 24" 
          width="24px" 
          height="24px">
            <path d="M11 11V5h2v6h6v2h-6v6h-2v-6H5v-2z" />
          </svg>
      </span>`
    return btn;
  }

  // ToC-Liste erstellen
  const tocList = createTocList();

  // Desktop-ToC einfügen
  if (tocDesktop) {
    tocDesktop.appendChild(tocList.cloneNode(true));
    console.log("🖥️ Desktop ToC injected");
  }

  // Mobile-ToC einfügen
  if (tocInline) {
    tocInline.innerHTML = ""; // Platzhalter leeren

    const header = document.createElement("div");
    header.className = "toc-header";
    header.setAttribute("data-open", "true");

    const title = document.createElement("span");
    title.className = "toc-title h5";
    title.innerHTML = `<span style="vertical-align: middle;">Inhaltsverzeichnis</span>`;

    const burger = createBurgerIcon();

    header.append(title, burger);

    const body = document.createElement("div");
    body.className = "toc-body";
    body.appendChild(tocList.cloneNode(true));
    // set initial open height
    requestAnimationFrame(() => {
      body.style.maxHeight = body.scrollHeight + "px";
    });

    // Sanfte Transition auf max-height
    body.style.overflow = "hidden";
    body.style.transition = "max-height 0.3s ease";
    body.style.maxHeight = body.scrollHeight + "px";

    tocInline.append(header, body);

    // Header-Toggle für das gesamte ToC
    header.addEventListener("click", toggleTocBody);

    //Funktion zum Togglen des gesamten ToC
    function toggleTocBody() {
      const isOpen = header.getAttribute("data-open") === "true";

      if (isOpen) {
        body.style.maxHeight = body.scrollHeight + "px";
        void body.offsetHeight; // Reflow
        body.style.maxHeight = "0px";
        header.setAttribute("data-open", "false");
        burger.setAttribute("aria-expanded", "false");
        burger.style.transform = "rotate(0deg)";
      } else {
        body.style.maxHeight = body.scrollHeight + "px";
        header.setAttribute("data-open", "true");
        burger.setAttribute("aria-expanded", "true");
        burger.style.transform = "rotate(-45deg)";
        if (tocInline.classList.contains("sticky")) {
          tocBody.style.maxHeight = "60vh";
          tocBody.style.overflowY = "auto";
        }
      }
    }
  }

  // Einzelne Sublisten-Toggles (H2 → H3)
  document.querySelectorAll(".toc-toggle").forEach((toggleBtn) => {
    toggleBtn.addEventListener("click", function (e) {
      e.stopPropagation(); // verhindert, dass Header-Toggle feuert
      const parentItem = toggleBtn.closest(".toc-item");
      const subList = parentItem?.querySelector(".toc-sublist");
      const body = document.querySelector(".toc-body");

      if (!subList) return;

      const isExpanded = toggleBtn.getAttribute("aria-expanded") === "true";
      toggleBtn.setAttribute("aria-expanded", String(!isExpanded));

      if (!isExpanded) {
        subList.style.maxHeight = subList.scrollHeight + "px";
        subList.classList.add("open");

        const newHeight = body.scrollHeight + subList.scrollHeight;
        body.style.maxHeight = newHeight + "px";
        if (tocInline.classList.contains("sticky")) {
          tocBody.style.maxHeight = "60vh";
          tocBody.style.overflowY = "auto";
        }
      } else {
        subList.style.maxHeight = subList.scrollHeight + "px";
        void subList.offsetHeight;
        subList.style.maxHeight = "0px";
        subList.classList.remove("open");

        // Nach Collapse warten und neu berechnen
        setTimeout(() => {
          body.style.maxHeight = body.scrollHeight + "px";
        }, 300);
      }
    });
  });

  // Smooth-Scroll für Hauptüberschriften (H2)
  document.querySelectorAll(".toc-toggle-text").forEach((link) => {
    link.addEventListener("click", function (e) {
      e.preventDefault();
      const id = this.getAttribute("href").slice(1);
      const target = document.getElementById(id);
      let offset = 0; // Basisoffset

      // Wenn das Ziel-Element kein margin-top oder padding-top hat → Offset = 55
      if (target) {
        const style = window.getComputedStyle(target);
        const marginTop = parseFloat(style.marginTop);
        const paddingTop = parseFloat(style.paddingTop);

        if (marginTop === 0 && paddingTop === 0) {
          offset = 55;
          console.log("Offset angepasst, weil kein margin/padding-top vorhanden ist:", offset);
        }
      }

      const isSticky = tocInline.classList.contains("sticky");
      const isVisible = window.getComputedStyle(tocInline).display !== "none";

      if (target) {
        const targetTop = target.getBoundingClientRect().top + window.scrollY;
        const tocTop =
          document.getElementById("toc-trigger-point").getBoundingClientRect()
            .top + window.scrollY;

        // Nur extra Offset, wenn das Ziel NACH dem TOC liegt
        if (targetTop > tocTop && isVisible) {
          if (isSticky) {
            collapseToc();
            offset += 20;
          } else {
            const tocHeight = tocInline.offsetHeight;
            offset = tocHeight - 60;
          }
        }
        if (targetTop < tocTop && isVisible && isSticky) {
          collapseToc();
        }

        if (targetTop < window.scrollY) {
          offset += 70;
        }

        requestAnimationFrame(() => {
          console.log("Neuer Frame angefragt");
          const correctedTop = target.getBoundingClientRect().top + window.scrollY;
          console.log("CorrectedTop:", correctedTop);
          console.log("Offset:", offset);
          const scrollTop = correctedTop - offset;
          console.log("Ziel:", scrollTop);
          window.scrollTo({ top: scrollTop, behavior: "smooth" });
          console.log("Scrollen abgeschlossen");
        });

        console.log("Höhe Element:", targetTop, "Offset:", offset, "korrigierter Top-Wert:", correctedTop, "Scroll-Ziel:", scrollTop);
      }
    });
  });

  // Smooth-Scroll für Unterüberschriften (H3)
  document.querySelectorAll(".toc-sublist a").forEach((link) => {
    link.addEventListener("click", function (e) {
      e.preventDefault();
      const id = this.getAttribute("href").slice(1);
      const target = document.getElementById(id);
      let offset = 40; // 2rem

      const isSticky = tocInline.classList.contains("sticky");
      const isVisible = window.getComputedStyle(tocInline).display !== "none";

      if (target) {
        const targetTop = target.getBoundingClientRect().top + window.scrollY;
        const tocTop =
          document.getElementById("toc-trigger-point").getBoundingClientRect()
            .top + window.scrollY;

        // Nur extra Offset, wenn das Ziel NACH dem TOC liegt
        if (targetTop > tocTop && isVisible) {
          if (isSticky) {
            collapseToc();
            offset += 20;
          } else {
            const tocHeight = tocInline.offsetHeight;
            offset = tocHeight -40;
          }
        }
        if (targetTop < tocTop && isVisible && isSticky) {
          collapseToc();
        }

        if (targetTop < window.scrollY) {
          offset += 70
        }

        // 👉 Sonderfall: zusätzlich +30px für FAQ-Fragen

        if (hasAncestorWithClass(target, "accordion__summary")) {
          offset += 50;
        }
        console.log("berechneter Offset:", offset);


        // Fix für Mobile: Layout erst stabilisieren lassen
          setTimeout(() => {
            requestAnimationFrame(() => {
              // Erneut messen (nach UI-Leisten / Header-Shift)
              const correctedTop = target.getBoundingClientRect().top + window.scrollY;
              const scrollTop = correctedTop - offset;

              // Noch kleiner Sicherheitsabstand für Safari Header
              const headerHeight = document.querySelector('header.section--site-header')?.offsetHeight || 0;
              const safeScrollTop = scrollTop - (headerHeight > 0 ? 5 : 0);

              window.scrollTo({ top: safeScrollTop, behavior: "smooth" });
              console.log("📱 Mobile ScrollFix aktiv: scrollTop", safeScrollTop, "HeaderHeight:", headerHeight, "Top-Ziel:", correctedTop);
            });
          }, 120); // 100–150 ms Delay funktioniert am zuverlässigsten auf iOS
      }
    });
  });

  //Prüfen, ob FAQ-Frage geklickt wurde
  function hasAncestorWithClass(el, className) {
    while (el && el !== document.body) {
      if (el.classList && el.classList.contains(className)) {
        return true;
      }
      el = el.parentElement;
    }
    return false;
  }

  // Scroll-Logik für Sticky-Verhalten
  let isSticky = false;
  const tocBody = document.querySelector(".toc-body");
  const triggerPoint = document.getElementById("toc-trigger-point");
  const tocSpacer = document.getElementById("toc-spacer");

  function collapseToc() {
    if (!tocBody) return;
    toggleTocBody();
    tocInline.classList.add("sticky");
    tocSpacer.classList.add("spacer-margin");
  }

  function expandToc() {
    if (!tocBody) return;
    tocInline.classList.remove("sticky");
    toggleTocBody();
    tocSpacer.classList.remove("spacer-margin");
  }

  function isTriggerVisible() {
    if (!triggerPoint) return false;
    const rect = triggerPoint.getBoundingClientRect();
    return rect.top >= 0;
  }

  // ---- Scroll-Handling optimiert mit requestAnimationFrame ----
let ticking = false;

window.addEventListener("scroll", () => {
  if (!ticking) {
    window.requestAnimationFrame(() => {
      const rect = tocInline.getBoundingClientRect();

      if (rect.top <= 0 && !isSticky) {
        isSticky = true;
        collapseToc();
      } else if (isTriggerVisible() && isSticky) {
        isSticky = false;
        expandToc();
      }

      ticking = false; // Frame abgeschlossen
    });

    ticking = true; // blockiere bis zum nächsten Frame
  }
});
});
